export default __webpack_public_path__ + "images/b92a3bc462b7761177402aa1eb1b3602.svg";